'use client'
/** Small −/＋ quantity stepper. Controlled; clamps at 1..max. */
export default function QtyStepper({
  value,
  onChange,
  min = 1,
  max = 9999,
  disabled = false,
}: {
  value: number
  onChange: (v: number) => void
  min?: number
  max?: number
  disabled?: boolean
}) {
  const dec = () => onChange(Math.max(min, value - 1))
  const inc = () => onChange(Math.min(max, value + 1))
  return (
    <div className="inline-flex items-center rounded-full border border-line bg-surface">
      <button
        type="button"
        onClick={dec}
        disabled={disabled || value <= min}
        aria-label="−"
        className="h-9 w-9 rounded-full text-lg leading-none text-ink disabled:opacity-40 hover:text-accent transition-colors"
      >
        −
      </button>
      <span className="min-w-[2.5ch] text-center text-sm font-semibold tabular-nums text-ink">
        {value.toLocaleString('fa-IR')}
      </span>
      <button
        type="button"
        onClick={inc}
        disabled={disabled || value >= max}
        aria-label="+"
        className="h-9 w-9 rounded-full text-lg leading-none text-ink disabled:opacity-40 hover:text-accent transition-colors"
      >
        +
      </button>
    </div>
  )
}
